var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-timer-sand"},[(_vm.sandIcon === 0)?_c('IconTimerSand',{attrs:{"size":20}}):_vm._e(),_vm._v(" "),(_vm.sandIcon === 1)?_c('IconTimerSandPaused',{attrs:{"size":20}}):_vm._e(),_vm._v(" "),(_vm.sandIcon === 2)?_c('IconTimerSandComplete',{attrs:{"size":20}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }